import { render } from "./CertificatesManager.vue?vue&type=template&id=7bb726ea&scoped=true"
import script from "./CertificatesManager.vue?vue&type=script&lang=js"
export * from "./CertificatesManager.vue?vue&type=script&lang=js"

import "./CertificatesManager.vue?vue&type=style&index=0&id=7bb726ea&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7bb726ea"]])

export default __exports__